/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type CreateDisplayConfigurationMutationVariables = Types.Exact<{
  input: Types.CreateConfigurationInput;
}>;


export type CreateDisplayConfigurationMutation = { __typename: 'Mutation', createDisplayConfiguration: { __typename: 'ConfigurationModel', id: string, name: string } };


export const CreateDisplayConfigurationDocument = gql`
    mutation CreateDisplayConfiguration($input: CreateConfigurationInput!) {
  createDisplayConfiguration(input: $input) {
    id
    name
  }
}
    `;
export type CreateDisplayConfigurationMutationFn = ApolloReactCommon.MutationFunction<CreateDisplayConfigurationMutation, CreateDisplayConfigurationMutationVariables>;

/**
 * __useCreateDisplayConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateDisplayConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDisplayConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDisplayConfigurationMutation, { data, loading, error }] = useCreateDisplayConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDisplayConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDisplayConfigurationMutation, CreateDisplayConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDisplayConfigurationMutation, CreateDisplayConfigurationMutationVariables>(CreateDisplayConfigurationDocument, options);
      }
export type CreateDisplayConfigurationMutationHookResult = ReturnType<typeof useCreateDisplayConfigurationMutation>;
export type CreateDisplayConfigurationMutationResult = ApolloReactCommon.MutationResult<CreateDisplayConfigurationMutation>;
export type CreateDisplayConfigurationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDisplayConfigurationMutation, CreateDisplayConfigurationMutationVariables>;